export const updateAction = () => {
    return {
        type: 'UPDATED_LIST_OF_BOTS'
    }
}